import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/pc/modals/');

export default function ListDModal() {
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    return (
        <div className={`${css.listD2} modal-listD2`}>
            <div className="listD2Box">
                <div className="listd-title1">{t('presale.product.modals.listD2_title1')}</div>
                <div className="listd-title2">{t('presale.product.modals.listD2_title2')}</div>
                <div className="listd-box">
                    <div className="listd-item">
                        <div className="listd-ms-box">
                            <div className="listd-ms1">{t('presale.product.modals.listD2_title_a1')}</div>
                            <div className="listd-ms2">{t('presale.product.modals.listD2_title_a2')}</div>
                        </div>
                        <div className="listd-img">
                            <EFPic
                                name={['console_customization.webp', 'console_customization.png']}
                                className="fullImgs"
                                alt={t('presale.product.modals.listD2_title_a1')}
                            />
                        </div>
                    </div>
                    <div className="listd-item">
                        <div className="listd-ms-box">
                            <div className="listd-ms1">{t('presale.product.modals.listD2_title_b1')}</div>
                            <div className="listd-ms2">{t('presale.product.modals.listD2_title_b2')}</div>
                        </div>
                        <div className="listd-img">
                            <EFPic
                                name={['console_monitor.webp', 'console_monitor.png']}
                                className="fullImgs"
                                alt={t('presale.product.modals.listD2_title_b1')}
                            />
                        </div>
                    </div>
                    <div className="listd-item">
                        <div className="listd-ms-box">
                            <div className="listd-ms1">{t('presale.product.modals.listD2_title_c1')}</div>
                            <div className="listd-ms2">{t('presale.product.modals.listD2_title_c2')}</div>
                        </div>
                        <div className="listd-img">
                            <EFPic name={['console_keep.webp', 'console_keep.png']} className="fullImgs" alt={t('presale.product.modals.listD2_title_c1')} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
